/* eslint-disable no-param-reassign */

function customTranslations(t) {
  t.de.TICKETS_BUY_PREFIX = ' ';
  t.de.TICKETS_BUY_SUFFIX = 'Reservieren';

  t.de.GUIDED_TOUR_BUY_TICKETS_PREFIX = 'Führung mit';
  t.de.GUIDED_TOUR_BUY_TICKETS_SUFFIX = 'Tickets reservieren';
  t.de.GUIDED_TOUR_BUY = 'Reservieren';

  t.de.MERCHANDISE_BUY = ' ';
  t.de.MERCHANDISE_BUY_SUFFIX_SINGULAR = 'Artikel reservieren';
  t.de.MERCHANDISE_BUY_SUFFIX_PLURAL = 'Artikel reservieren';
}

export default customTranslations;
